// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36ECD","productName":"Table_productName__2yLOE"};